const initialUserState = {
    userData: {}
};

export default initialUserState;